import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ExternalLink, X } from 'lucide-react';

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PrivacyPolicyModal({ isOpen, onClose }: PrivacyPolicyModalProps) {
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const handleOpenExternal = () => {
    window.open("https://www.iubenda.com/privacy-policy/85763415", "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full h-[90vh] p-0 gap-0 flex flex-col">
        <DialogHeader className="px-6 py-4 border-b bg-card flex-shrink-0">
          <DialogTitle className="text-lg font-semibold">Privacy Policy</DialogTitle>
        </DialogHeader>
        
        <div className="relative flex-1 bg-background min-h-0">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-muted/50 z-10">
              <div className="flex flex-col items-center gap-2">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
                <p className="text-sm text-muted-foreground">Caricamento Privacy Policy...</p>
              </div>
            </div>
          )}
          
          <iframe
            src="https://www.iubenda.com/privacy-policy/85763415"
            className="w-full h-full border-0"
            title="Privacy Policy"
            onLoad={handleIframeLoad}
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
            loading="lazy"
          />
        </div>
        
        <div className="px-6 py-3 border-t bg-muted/30 flex-shrink-0">
          <div className="flex items-center justify-between">
            <p className="text-xs text-muted-foreground">
              Questa Privacy Policy è fornita da{" "}
              <a 
                href="https://www.iubenda.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="underline hover:text-foreground"
              >
                iubenda
              </a>
            </p>
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={handleOpenExternal}
                className="gap-2"
              >
                <ExternalLink className="h-4 w-4" />
                Apri in nuova finestra
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={onClose}
                className="gap-2"
              >
                <X className="h-4 w-4" />
                Chiudi
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
